// extracted by mini-css-extract-plugin
export var heading__text = "index-module--heading__text--edf62";
export var heading__textH2 = "index-module--heading__text--h2--dfb47";
export var heading__textH3 = "index-module--heading__text--h3--b2805";
export var heading__wrapper = "index-module--heading__wrapper--32832";